// Note: vendor names are not translated
export const KEYLESS_PROVIDERS = [
  { flag: 'brivoAvailable', name: 'Brivo' },
  { flag: 'saltoSpaceAvailable', name: 'Salto Space' },
  { flag: 'saltoKSAvailable', name: 'Salto KS' },
  { flag: 'swiftlaneAvailable', name: 'Swiftlane' },
  { flag: 'butterflyAvailable', name: 'ButterflyMX' },
  { flag: 'remoteLockAvailable', name: 'RemoteLock' },
  { flag: 'pointCentralAvailable', name: 'PointCentral' },
  { flag: 'iglooWorkAvailable', name: 'Iglooworks' },
  { flag: 'dormakabaAvailable', name: 'Dormakaba' },
  { flag: 'latchAvailable', name: 'Latch' },
  { flag: 'openpathAvailable', name: 'OpenPath' },
  { flag: 'twoNAvailable', name: '2N' },
  { flag: 'akuvoxAvailable', name: 'Akuvox' },
  { flag: 'rentlyAvailable', name: 'Rently' },
  { flag: 'visionlineAvailable', name: 'Visionline' },
] as const

export type KeylessProviderFlag = (typeof KEYLESS_PROVIDERS)[number]['flag']
